import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CourseCobrandSettingsPage from './Pages/CourseCobrandSettingsPage';

const CourseCobrandSettingsRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route default>
                <CourseCobrandSettingsPage />
            </Route>
        </Switch>
    );
};

export default CourseCobrandSettingsRouter;
